import appColorStyles from '../../../app/styles/appColorStyles'

const bookingConfirmationStyle = {
  root: {
    flexGrow: 1,
  },
  horizontalContainer: {
    display: 'flex',
  },
  infoGridContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    backgroundColor: 'var(--jy-navy-900, #00253d)',
    justifyContent: 'center',
    alignItems: 'stretch',
    padding: 0,
    margin: 0,
  },
  clientContainerDark: {
    backgroundColor: appColorStyles.primary,
    flex: '1 1 0',
    minWidth: '120px',
    minHeight: '84px',
    padding: 'var(--sp-3, 12px) var(--sp-3, 12px)',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '8px',
  },
  infoContainerDark: {
    backgroundColor: appColorStyles.primary,
    flex: '1 1 0',
    minWidth: '120px',
    minHeight: '84px',
    padding: 'var(--sp-3, 12px) var(--sp-3, 12px)',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '8px',
  },
  infoContainerLight: {
    backgroundColor: appColorStyles.secondary,
    flex: '1 1 0',
    minWidth: '120px',
    minHeight: '84px',
    padding: 'var(--sp-3, 12px) var(--sp-3, 12px)',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '8px',
  },
  infoHeader: {
    color: 'white',
    fontSize: '11px',
    fontWeight: 600,
    letterSpacing: '0.5px',
    margin: 0,
    lineHeight: 1.2,
    whiteSpace: 'nowrap',
  },
  infoDetail: {
    color: 'white',
    fontSize: '16px',
    fontWeight: 500,
    margin: 0,
    lineHeight: 1.2,
  },
  rootDetailContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  detailContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    marginTop: 'var(--sp-8, 32px)',
  },
  detailDividerContainer: {
    marginBottom: 'var(--sp-8, 32px)',
  },
  journeyDetailListPrimaryText: {
    fontSize: '10px',
    color: appColorStyles.fieldFontColor,
  },
  journeyDetailListSecondaryText: {
    fontSize: '12px',
  },
  mapContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  map: {
    height: '250px',
    width: '100%',
  },
  additionalInfoHeader: {
    color: appColorStyles.fieldFontColor,
    fontSize: 'var(--fs-12, 0.75rem)',
    marginTop: 'var(--sp-2, 8px)',
  },
  additionalInfoValue: {
    fontSize: 'var(--fs-13, 0.8125rem)',
  },
  actionContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 'var(--sp-8, 32px)',
  },
  actionButton: {
    marginLeft: 'var(--sp-2, 8px)',
  },
  progressTitle: {
    marginLeft: 'var(--sp-8, 32px)',
  },
  progressContainer: {
    marginTop: 'var(--sp-12, 48px)',
  },
  priceCaviat: {
    marginTop: 'var(--sp-5, 20px)',
  },
}

export default bookingConfirmationStyle
